import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
  form: {
    width: "auto",
    marginTop: "0px",
    marginRight: "15px",
    marginLeft: "15px",
    
  },
  formControl: {
    padding: "8px",
    maxHeight: "35px",
    maxWidth: "331px",
    
  },
  menuItem: {
    "&:hover": {
      borderLeft: "4px solid #098B8B",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  dropdown: {
    backgroundColor: "#FFFFFF",
    boxSizing: "border-box",
    borderRadius: "8px",
    height: "35px",
    fontSize: "14px",
    [`& fieldset`]: {
      borderRadius: 8,
      fontSize: 14,
    },
  },
  notes: {
    backgroundColor: "#FFFFFF",
    boxSizing: "border-box",
    borderRadius: "8px",
    fontSize: "14px",
    [`& fieldset`]: {
      borderRadius: 8,
      fontSize: 14,
    },
  },
  field: {
    borderRadius: "8px",
    height: "35px",
    
  },
}));

export const styleSearch = makeStyles((theme) => ({
  table: {
    minWidth: 500,
  },
  buttonSearch: {
    color: "#ffffff",
    background: "#7EBDCE",
    "&:hover": { color: "white", background: "#099F9F" },
  },
  buttonClear: {
    color: "#666666",
    border: "solid 1px",
    background: "#ffffff",
    "&:hover": { color: "#099F9F", background: "#ffffff" },
  },
  form: {
    paddingTop: "0px",
    padding: "12px",
    
  },
  card: {
    marginTop: "0px",
    marginLeft: "8px",
    border: "0",
    boxShadow: "none",
    //maxWidth: "699.5px",
    maxWidth: "100%",
    maxHeight: "auto",
    backgroundColor: "#E0F2F7",
  },
  formControl: {
    padding: "8px",
    maxHeight: "48px",
    maxWidth: "331px",
  },
  select: {
    paddingTop: "10.5px",
    paddingBottom: "10.5px",
  },
  menuItem: {
    "&:hover": {
      borderLeft: "4px solid #098B8B",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export const searchStyles = makeStyles ((theme) => ({
  root: {
    width: "92%",
    marginTop: "20px",
    //marginLeft: "10px",
  },
  column: {
    flexBasis: "39.6%",
    marginRight: 10,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
    wordBreak: 'normal',
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
    wordBreak: 'normal'
  },
  checked: {
    marginRight: 20
  }
}));
